import script from "./OwnerReport.vue?vue&type=script&setup=true&lang=js"
export * from "./OwnerReport.vue?vue&type=script&setup=true&lang=js"

import "./OwnerReport.vue?vue&type=style&index=0&id=30278378&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30278378"]])

export default __exports__